//Import asset file(s) used by this module.
import '../../../assets/skins/SystemMessageAssets';

import AbstractInstaller from "../application/AbstractInstaller";
import AppInstaller from '../application/AppInstaller';
import SkinKeyRegistry from '../ui/SkinKeyRegistry';
import SystemMessageCommand from './controller/SystemMessageCommand';
import SystemMessageEvent from './model/SystemMessageEvent';
import SystemMessagePopupMediator from './view/SystemMessagePopupMediator';

export default class SystemMessageInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        SkinKeyRegistry.SYSTEM_MESSAGE_POPUP_SKIN = this._mapMediator(SystemMessagePopupMediator, lib.SystemMessageAssets.SystemMessagePopupSkin);

        commands.add(SystemMessageEvent.OPEN, SystemMessageCommand);

        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "SystemMessageAssets");

        this._addAssetsToConfigurationManifest(
            { id: "asset-loading-language", src: "assets-localized/en/language/asset-loading-language.lp", type: "json" }, // Load as fallback for when an asset loading error occurs and we need to give feedback to the user
        );
    }
}